export default __webpack_public_path__ + "static/media/Harry's Wand - Img - Final (2)_05.a9a55c45.jpg";